import { render, staticRenderFns } from "./SPRSearchSort.vue?vue&type=template&id=770ce7ea"
import script from "./SPRSearchSort.vue?vue&type=script&lang=js"
export * from "./SPRSearchSort.vue?vue&type=script&lang=js"
import style0 from "./SPRSearchSort.vue?vue&type=style&index=0&id=770ce7ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports